<div class="e-info-tile">
    <h2>
        <i [class]="tile.icon"></i>
        {{ tile.title }}
    </h2>
    <p>{{ tile.description }}</p>
    <button mat-button color="primary" (click)="buttonClicked()">{{ tile.buttonLabel }}</button>
</div>
  